import { $themeBreakpoints } from "@themeConfig"

export default {
  namespaced: true,
  state: {
    windowWidth: 0,
    shallShowOverlay: false,
    enteredRoutes: JSON.parse(localStorage.getItem("enteredRoutes")),
    enteredRouteIndex: JSON.parse(localStorage.getItem("enteredRouteIndex")),
  },
  getters: {
    currentBreakPoint: (state) => {
      const { windowWidth } = state
      if (windowWidth >= $themeBreakpoints.xl)
        return "xl"
      if (windowWidth >= $themeBreakpoints.lg)
        return "lg"
      if (windowWidth >= $themeBreakpoints.md)
        return "md"
      if (windowWidth >= $themeBreakpoints.sm)
        return "sm"
      return "xs"
    },
  },
  mutations: {
    UPDATE_WINDOW_WIDTH(state, val) {
      state.windowWidth = val
    },
    TOGGLE_OVERLAY(state, val) {
      state.shallShowOverlay = val !== undefined ? val : !state.shallShowOverlay
    },
    SET_ENTERED_ROUTES(state, routes) {
      state.enteredRoutes = routes
    },
    SET_ENTERED_ROUTE_INDEX(state, index) {
      state.enteredRouteIndex = index
    },
  },
  actions: {
    updateEnteredRoutes({ commit }, routes) {
      commit("SET_ENTERED_ROUTES", routes)
    },
  },
}
